/*
 * GLOBAL THEME VARS
 */
var viewport = $(window).width(),
    viewportHeight = $(window).height(),
    loader = $(".ajax-load");
